import { getJSON } from '../utils/json';

export default () => ({
    async getPosts() {
        return await getJSON(
            `https://graph.instagram.com/17841413039609486/media?access_token=IGQVJXYlF3S1g3MU9wc3AyeFloYkpISlR5QmFmbnRZAb2l4NEJuYjBINm1aNkltcFNtaFNnU25zcnJkSjc2UkpuRnhkOFQzVlEzY3VZAUC1WcEJLRkh3MUxTbjZApV1lQTFVqX09pZA3Q0MWpyMmwzRE5ZAVQZDZD&fields=media_url,permalink,thumbnail_url,media_type,caption`
        );
    },
});
